import http from '@/http';

export default {

    authenticate(credentials) {
        return http.post('/ldap', credentials);
    },
    // changePassword(credentials) {
    //     return http.patch('/auth', credentials);
    // },
};



// WEBPACK FOOTER //
// ./src/api/auth.js